export const formFieldsActivityArea = [
  {
    // label: 'Σχετικά με τον Εγκαταστάτη',
    type: 'textarea',
    name: 'marketing',
    id: 'marketing',
    size: 'large',
    options: [],
    placeholder: 'Εισάγετε περιγραφή',
    span: 24,
    rows: 7,
    asterisk: true,
    maxLength: 500,
    rules: [
      { required: true, message: 'Το πεδίο είναι υποχρεωτικό'},
      // () => ({
      //   validator(_, value) {
      //     if (!value) return Promise.resolve(); // Allow empty values
          
      //     if (value.length > 499) {
      //       return Promise.reject(`Το μέγιστο όριο επιτρεπόμενων χαρακτήρων είναι 500.`);
      //     }
    
      //     return Promise.resolve();
      //   },
      // }),
    ],
  },
]